import { render } from "./TaskDescription.vue?vue&type=template&id=c0435d72"
import script from "./TaskDescription.vue?vue&type=script&lang=js"
export * from "./TaskDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__